import { useState } from 'react';
import ReleaseNotesModal from './ReleaseNotesModal';
import { API_BASE, IS_CAPACITOR } from '../api/config';
import '../styles/galaxy.css';

function AboutModal({ onClose }) {
  const [showReleaseNotes, setShowReleaseNotes] = useState(false);
  return (
    <div className="galaxy-info-overlay" onClick={onClose}>
      <div className="galaxy-info-modal about-modal" onClick={(e) => e.stopPropagation()}>
        <button className="galaxy-info-close" onClick={onClose}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <h3 className="galaxy-info-title">About Stellar</h3>
        <span className="release-notes-version" style={{ marginBottom: 8, display: 'inline-block' }}>v1.10</span>

        <p className="galaxy-info-text" style={{ marginBottom: 20 }}>
          Stellar is a music discovery app that maps artists into a living musical universe. Explore galaxies of related artists, build your personal universe of favorites, and discover new music through visual connections between artists.
        </p>

        <div className="about-section-label">Powered by</div>

        <div className="about-attribution">
          <div className="about-attribution-item">
            <span className="about-service-name">Last.fm</span>
            <span className="galaxy-info-text">
              Artist similarity, genres, and metadata
            </span>
          </div>
          <div className="about-attribution-item">
            <span className="about-service-name">Deezer</span>
            <span className="galaxy-info-text">
              Artist images, fan counts, and track previews
            </span>
          </div>
        </div>

        <div className="about-links">
          <a href={IS_CAPACITOR ? `${API_BASE}/privacy` : '/privacy'} target="_blank" rel="noopener noreferrer" className="about-link">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            Privacy Policy
          </a>
          <a href="mailto:Stellarmusic.app@gmail.com?subject=App%20Feedback" className="about-link">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            Contact Us
          </a>
          <button
            className="about-link"
            onClick={() => setShowReleaseNotes(true)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="9" y1="13" x2="15" y2="13" />
              <line x1="9" y1="17" x2="13" y2="17" />
            </svg>
            Release Notes
          </button>
        </div>
      </div>

      {showReleaseNotes && <ReleaseNotesModal onClose={() => setShowReleaseNotes(false)} />}
    </div>
  );
}

export default AboutModal;
